export default __webpack_public_path__ + "static/media/hourglass.548810be.png";